"use client";
//'import classes from "../styles/Analysis.module.css";
export default function TopMenu() {
return(
<div>
    <h1> Veolia - CSV Analysis Tool</h1></div>
)
}